import React, { useState } from 'react';
import { Button } from '@digital/ui';
import { getIsAjusteOrcamentario } from '@app/api/sas/ordemCompra';
import { useRecoilValue } from 'recoil';
import { ordemCompraIdState } from '../atoms';
import ModalDocumentacaoRequisitante from './ModalDocumentacaoRequisitante';

const AjusteOrcamentario = () => {
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [exibirModal, setExibirModal] = useState(false);

    const handleIsAjusteOrcamentario = () => {
        getIsAjusteOrcamentario(ordemCompraId).then((data: any) => {
            if (data && data.isAjuste) {
                setExibirModal(true);
            }
        });
    }

    return (
        <>
            <Button title='Ajuste Orçamentário' type='primary' onClick={handleIsAjusteOrcamentario} />
            <ModalDocumentacaoRequisitante open={exibirModal} onClose={() => setExibirModal(false)} />
        </>
    );
};

export default AjusteOrcamentario;
